export enum AddrDeliveryTypeCdEnum {
  MailStop = <any>'MailStop',
  MailingAddress = <any>'MailingAddress',
  PostOffice = <any>'PostOffice',
  RuralRoute = <any>'RuralRoute',
}
